module.exports = __webpack_public_path__ + "static/media/DE_Logo-PNG_White.e37727c6.png";